import React from 'react'
import { Link as NavLink } from 'react-router'
import classnames from 'classnames'
import { A, Icon } from '@driftt/tide-core-legacy'

const EndNode = ({
  label,
  path,
  icon,
  className,
  onClick,
  exact = true,
  external = typeof path === 'string' && path.match(/^http/),
  disabled,
  ...rest // captures native html attributes
}) => {
  const LinkProps = {
    exact: exact,
    to: path,
    activeClassName: "tc-subnav-link--active"
  }
  const AnchorTagProps = {
    href: path
  }

  const Link = !external ? NavLink : A
  return (
    <Link
      className={classnames('tc-subnav-link', { 'tc-subnav-link--disabled': disabled }, className)}
      onClick={() => onClick && onClick()}
      {...(external ? AnchorTagProps : LinkProps)}
      {...rest}
    >
      {(icon) && <Icon name={icon} height="12" width="12" />}
      {label}
    </Link>
  )
}

export default EndNode



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Subnav/Nodes/EndNode.js